import THEMES from 'constants/theme'

const styles = (theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    height: '60px',
    backgroundColor: theme.palette.background.topBar,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.background.topBar,
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.topBar,
        }
      : {}),
  },
  logo: {
    fontSize: 0,
    width: '50px',
    [theme.breakpoints.up('md')]: {
      width: '60px',
    },
  },
  toolbar: {
    minHeight: 68,
  },
})

export default styles
